
import Vue from "vue";
import data from "@/datatables/users/team";
import datatable from "@/utils/datatable/components/datatable.vue";
export default Vue.extend({
  name: "consultutns-list",
  components:{
    datatable
  },
  data(){
    return {
        data
    }
  },
});
